import moment from 'moment';
import { logoutUser } from 'store/app/authentication/login/actions';

export const storeToken = (token) => {
    console.log('token: ', token);
    const { accessToken, expiresInSec, tokenType } = token;
    const expires = moment().unix() + expiresInSec;
    localStorage.setItem("token", accessToken);
    localStorage.setItem("expires_in", expires);
    localStorage.setItem("token_type", tokenType);
}

export const getToken = (dispatch) => {
    const accessToken = localStorage.getItem('token');
    const expiresIn = localStorage.getItem('expires_in');

    return new Promise((resolve) => {
        const diff = moment.unix(Number(expiresIn)).diff(moment(), 'minutes');

        if (accessToken && diff > 5) {
            resolve(accessToken);
        } else {
            dispatch && dispatch(logoutUser());
            resolve(accessToken);
        }
    });
};

export const getPager = (totalItems, currentPage, pagesize) => {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pagesize = pagesize || 10;

    // calculate total pages
    const totalPages = Math.ceil(totalItems / pagesize);

    let startPage;
    let endPage;
    if (totalPages <= 10) {
        // less than 10 total pages so show all
        startPage = 1;
        endPage = totalPages;
    } else {
        // more than 10 total pages so calculate start and end pages
        if (currentPage <= 6) {
            startPage = 1;
            endPage = 10;
        } else if (currentPage + 4 >= totalPages) {
            startPage = totalPages - 9;
            endPage = totalPages;
        } else {
            startPage = currentPage - 5;
            endPage = currentPage + 4;
        }
    }

    // calculate start and end item indexes
    const startIndex = (currentPage - 1) * pagesize;
    const endIndex = Math.min(startIndex + pagesize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    const pages = [...Array(endPage + 1 - startPage).keys()].map((i) => startPage + i);

    // return object with all pager properties required by the view

    return {
        totalItems,
        currentPage,
        pagesize,
        totalPages,
        startPage,
        endPage,
        startIndex,
        endIndex,
        pages,
    };
};

export const rolesOptions = (roles) => {
    const rolesListItems = [];
    roles.forEach((role) => {
        const { Id, RoleName } = role;
        rolesListItems.push({
            label: RoleName,
            value: Id
        })
    })
    return rolesListItems;
}

export const formRecordsOptions = (roles) => {
    const formRecordsListItems = [];
    roles.forEach((role) => {
        const { Id, FarmName } = role;
        formRecordsListItems.push({
            label: FarmName,
            value: Id
        })
    })
    return formRecordsListItems;
}

export const reportNameOptions = (report) => {
    const reportNameItems = [];
    report.forEach((role) => {
        const { Id, ReportName, CustomFormula, Fields, Metrics } = role;
        let reportFormula;
        if (Metrics === "custom") {
            const formula = CustomFormula?.split(" ");
            const formulaArray = formula?.map((ops) => {
                const fieldArr = ops.includes("FRMFLD") ? Fields?.filter((field) => field.FieldId === ops) : [ops];
                const field = fieldArr[0]?.FieldName || fieldArr[0];
                return field;
            })
            reportFormula = formulaArray?.join(" ");
        }
        else {
            reportFormula = Metrics;
        }
        reportNameItems.push({
            label: `${ReportName} | ${reportFormula}`,
            value: Id,
            formula: reportFormula,
        })
    })
    return reportNameItems;
}

export const moveRepeatedOrderIdsToEnd = (arr, key) => {
    const seen = new Set();
    const unique = [];
    const repeated = [];

    arr?.forEach(item => {
        const value = item[key];
        if (seen.has(value)) {
            repeated.push(item);
        }
        else {
            seen.add(value);
            unique.push(item);
        }
    });
    const combined = [...unique, ...repeated];
    return combined?.map((item, index) => ({
        ...item,
        [key]: index + 1,
    }));
}

export const technicalManagerOptions = (managers) => {
    const managerListItems = [];
    managers.forEach((manager) => {
        const { DisplayName, Email } = manager;
        managerListItems.push({
            label: `${DisplayName} | ${Email}`,
            value: Email
        })
    })
    return managerListItems;
}
export const usersOptions = (users) => {
    const usersItems = [];
    users.forEach((user) => {
        const { DisplayName, Email, Id } = user;
        usersItems.push({
            label: `${DisplayName} | ${Email}`,
            value: Id
        })
    })
    return usersItems;
}
export const customersOptions = (customers) => {
    const customerListItems = [];
    customers.forEach((customer) => {
        const { CustomerName, Email } = customer;
        customerListItems.push({
            label: `${CustomerName} | ${Email}`,
            value: Email
        })
    })
    return customerListItems;
}
export const locationsOptions = (locations) => {
    const locationListItems = [];
    locations.forEach((location) => {
        const { locationName, recordType } = location;
        locationListItems.push({
            label: locationName,
            value: locationName,
            type: recordType
        })
    })
    return locationListItems;
}
export const regionsOptions = (regions) => {
    const regionListItems = [];
    regions.forEach((region) => {
        const { Id, RegionName } = region;
        regionListItems.push({
            label: RegionName,
            value: Id
        })
    })
    return regionListItems;
}
export const statesOptions = (states) => {
    const stateListItems = [];
    states.forEach((state) => {
        const { Id, StateName, RegionId } = state;
        stateListItems.push({
            label: StateName,
            value: Id,
            regionId: RegionId
        })
    })
    return stateListItems;
}
export const districtOptions = (states) => {
    const districtListItems = [];
    states.forEach((state) => {
        const { Id, District } = state;
        districtListItems.push({
            label: District,
            value: Id
        })
    })
    return districtListItems;
}
export const anticoccidialOptions = (anticoccidials) => {
    const anticoccidialListItems = [];
    anticoccidials.forEach((anticoccidial) => {
        const { Id, Anticoccidial } = anticoccidial;
        anticoccidialListItems.push({
            label: Anticoccidial,
            value: Id
        })
    })
    return anticoccidialListItems;
}
export const agpOptions = (agps) => {
    const agpListItems = [];
    agps.forEach((agp) => {
        const { Id, Agp } = agp;
        agpListItems.push({
            label: Agp,
            value: Id
        })
    })
    return agpListItems;
}
export const probioticOptions = (probiotics) => {
    const probioticListItems = [];
    probiotics.forEach((probiotic) => {
        const { Id, Probiotic } = probiotic;
        probioticListItems.push({
            label: Probiotic,
            value: Id
        })
    })
    return probioticListItems;
}

export const formFieldOptions = (formFields) => {
    const locationListItems = [];
    formFields.forEach((formField) => {
        const { FieldName, Id } = formField;
        locationListItems.push({
            label: FieldName,
            value: Id
        })
    })
    return locationListItems;
}